import * as React from 'react';
import { useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import ExpandableCard from './ExpandableCard';
import { SCHEDULE_CONSTANTS } from '../constants/scheduleConstants';
import { useLocation } from '../context/LocationContext';
import { getEventsForScheduleByLocation } from '../config/eventsConfig';

const useStyles = makeStyles({
  container: {
    maxWidth: '900px',
    margin: '4rem auto',
    padding: '0 1rem',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    textAlign: 'center',
    color: 'var(--primary-color)',
    marginBottom: '1.5rem',
    lineHeight: '1',
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.5rem',
    justifyContent: 'center',
  },
  muted: {
    fontSize: '18px',
    color: '#6a8ca3',
  },
  directionsLink: {
    display: 'inline-block',
    marginTop: '1rem',
    padding: '0.5rem 1rem',
    backgroundColor: 'var(--primary-color)',
    color: '#fff8e1',
    textDecoration: 'none',
    borderRadius: '5px',
    fontWeight: 600,
    transition: 'background-color 0.3s ease',
    selectors: {
      '&:hover': {
        backgroundColor: 'var(--primary-hover)',
      },
    },
  },
});

const ScheduleSection: React.FC = () => {
  const classes = useStyles();
  const [expandedCards, setExpandedCards] = useState<{[key: string]: boolean}>({});
  
  // Get current location from context
  const { currentLocation } = useLocation();
  
  // Get events filtered by location
  const enabledEvents = getEventsForScheduleByLocation(currentLocation);

  const toggleCard = (cardKey: string) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardKey]: !prev[cardKey]
    }));
  };

  return (
    <section id={SCHEDULE_CONSTANTS.SECTION_ID} className={classes.container} aria-labelledby={SCHEDULE_CONSTANTS.EVENTS_TITLE_ID}>
      <h2 id={SCHEDULE_CONSTANTS.EVENTS_TITLE_ID} className={classes.sectionTitle}>
        {SCHEDULE_CONSTANTS.SECTION_TITLE}
      </h2>
      <div className={classes.grid}>
        {enabledEvents.map((event) => (
          <ExpandableCard 
            key={event.key}
            cardKey={event.key} 
            title={event.title}
            date={event.date}
            city={event.city}
            expandedCards={expandedCards}
            toggleCard={toggleCard}
          >
            <p className={classes.muted} style={{ fontStyle: 'italic'}}>{event.description}</p>
            {event.schedule.map((item, index) => (
              <p key={index} className={classes.muted} style={{ textDecoration: 'underline' }}>{item}</p>
            ))}
            <p className={classes.muted}>{event.venue}</p>
            <p className={classes.muted}>{event.includes}</p>
            <a 
              href={event.directionsUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={classes.directionsLink}
              onClick={(e) => e.stopPropagation()}
            >
              {SCHEDULE_CONSTANTS.DIRECTIONS_TEXT}
            </a>
          </ExpandableCard>
        ))}
      </div>
    </section>
  );
};

export default ScheduleSection;